export const UPDATE_COUNTRIES_TRACEABILITY =  {
    ACTIVATION_PROFILES: 'ACTIVATION_PROFILES',
    NONE: 'NONE',
};

export const STUDY_PLAN_TYPES = {
  SCENARIO_A: 1,
  SCENARIO_B: 2,
};

export const MUST_VALIDATE_FIELDS = [
  "studyPlanName",
  "studyPlanDescr",
  "PAUSE_BIGGER_THAN_ENROLLED_SUBJECTS",
];
